import commonMapping from "@/mapping/common";

export const upnp = {
  upnp_enable: commonMapping.intToBoolean,
};

export default upnp;
